import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import RenderDateInputField from 'components/form/InputFields/RenderDateInputField';
import translate from 'components/hoc/translate';

const MonthFilter = (props) => {
    const {
        floatingLabelFixed,
        fullWidth,
        label,
        source,
        translate,
    } = props;

    return (
        <Field
            component={ RenderDateInputField }
            floatingLabelFixed={ floatingLabelFixed }
            fullWidth={ fullWidth }
            label={ translate(label) || '' }
            name={ `${ source }[value]` }
            type='month'
        />
    );
};

MonthFilter.propTypes = {
    floatingLabelFixed: PropTypes.bool,
    fullWidth: PropTypes.bool,
    label: PropTypes.string,
    source: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(MonthFilter);



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/MonthFilter.js